<template>
    <div v-if="element && element.style && element.style.customCss" v-html="'<style>' + element.style.customCss + '</style>'"></div>
    <div class="sk-element-wrapper" :class="element.id + '-wrapper'" v-if="element.props" :style="styleWrapper" @dblclick.stop="onClick()">
        <div :id="element.id" :style="styleObject" class="carousel twpb-slider slide d-inline-block" :class="[{ 'carousel-fade': element.props.fadeAnimation }, element.props.themeStyle]" data-bs-ride="carousel">
            <div v-if="element.props.enableIndicators" class="carousel-indicators">
                <button type="button" :data-bs-target="'#' + element.id" :data-bs-slide-to="0" class="active" aria-current="true" :aria-label="element.props.items[0].title"></button>
                <template v-for="(slide, index) in element.props.items" :key="index">
                    <button v-if="index > 0" type="button" :data-bs-target="'#' + element.id" :data-bs-slide-to="index" :aria-label="slide.title"></button>
                </template>
            </div>
            <div class="carousel-inner">
                <template v-for="(slide, index) in element.props.items" :key="index">
                    <div class="carousel-item" :class="{ active: index === 0 }" :data-bs-interval="element.props.interval">
                        <img v-if="slide.image && slide.image !== '' && slide.image !== 'null'" :src="slide.image" class="" :style="imgStyleObject" alt="" />
                        <div v-else class="no-image">Select Slider Images</div>
                        <div v-if="(slide.title !== '' && slide.title !== 'null') || (slide.text !== '' && slide.text !== 'null')" class="carousel-caption d-none d-md-block" :style="captionStyle">
                            <h5 v-if="slide.title !== ''" :style="sliderTitleStyleObject">{{ slide.title }}</h5>
                            <p v-if="slide.text !== ''" :style="sliderTextStyleObject">{{ slide.text }}</p>
                        </div>
                    </div>
                </template>
            </div>

            <template v-if="element.props.enableControlButtons">
                <!-- Controls -->
                <button class="carousel-control-prev" type="button" :data-bs-target="'#' + element.id" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" :data-bs-target="'#' + element.id" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
                <!-- #Controls -->
            </template>
        </div>
    </div>
</template>
<script>
export default {
    name: "Slider",
    props: {
        element: {
            required: true,
            type: Object,
        },
    },
    methods: {
        onClick() {
            this.$emit("onClick", this.element);
        },

        checkInputValue(value) {
            if (value && value != "0px" && value != "0%" && value != "0rem") {
                return true;
            } else {
                return false;
            }
        },

        checkTwoValuesReturn(first, second) {
            if (this.checkInputValue(first)) {
                return first;
            } else if (this.checkInputValue(second)) {
                return second;
            } else {
                return "auto";
            }
        },
    },
    computed: {
        styleObject() {
            const s = this.element.style;
            return {
                ...(s.width && s.width !== "0" && s.width !== "0px" && s.width !== "0%" && s.width !== "0rem" ? { width: s.width } : {}),
                ...(s.height && s.height !== "0" && s.height !== "0px" && s.height !== "0%" && s.height !== "0rem" ? { height: s.height } : {}),
                backgroundColor: s.backgroundColor,
                color: s.color,
                ...(s.borderRadius && s.borderRadius !== "0px 0px 0px 0px" ? { borderRadius: s.borderRadius } : {}),
            };
        },
        styleWrapper() {
            const s = this.element.style;
            return {
                textAlign: s.imageAlign || s.textAlign,
                ...(s.padding && s.padding !== "0px 0px 0px 0px" ? { padding: s.padding } : {}),
                ...(s.margin && s.margin !== "0px 0px 0px 0px" ? { margin: s.margin } : {}),
            };
        },
        imgStyleObject() {
            const s = this.element.style;
            // mirror the published output (SliderController): image always fills the slider
            // width; height only when a fixed Fit Height is set (with object-fit)
            return {
                width: "100%",
                ...(this.checkInputValue(s.fitHeight) ? { height: s.fitHeight } : {}),
                ...(s.borderRadius && s.borderRadius !== "0px 0px 0px 0px" ? { borderRadius: s.borderRadius } : {}),
                objectFit: s.objectFit && s.objectFit !== "none" ? s.objectFit : "cover",
            };
        },
        captionStyle() {
            const s = this.element.style;
            const isFull = s.captionWidth === "full";
            const style = {
                padding: s.captionPadding ? s.captionPadding : "20px",
                textAlign: isFull && s.captionTextAlign ? s.captionTextAlign : "center",
            };
            style.width = isFull ? "80%" : "auto";
            if (s.captionBorderRadius && s.captionBorderRadius !== "0px 0px 0px 0px") style.borderRadius = s.captionBorderRadius;
            if (s.captionBorder && String(s.captionBorder).trim() !== "") style.border = s.captionBorder;
            const bg = s.captionBackgroundColor;
            const op = s.captionOpacity;
            const hasOpacity = op !== "" && op !== undefined && op !== null && Number(op) !== 1;
            if (bg && hasOpacity) {
                const pct = Math.max(0, Math.min(100, Number(op) * 100));
                style.backgroundColor = `color-mix(in srgb, ${bg} ${pct}%, transparent)`;
            } else {
                // not set → transparent (no forced dark scrim), so existing sliders aren't altered
                style.backgroundColor = bg ? bg : "transparent";
            }
            return style;
        },
        sliderTitleStyleObject() {
            const s = this.element.style;
            return {
                color: s.slideTitleColor ? s.slideTitleColor : "#ffffff",
                ...(s.titleFont === "heading" ? { fontFamily: "var(--hedings-font, var(--primary-font, sans-serif))" } : {}),
                ...(s.slideTitleSize ? { fontSize: s.slideTitleSize } : {}),
            };
        },
        sliderTextStyleObject() {
            const s = this.element.style;
            return {
                color: s.slideTextColor ? s.slideTextColor : "#ffffff",
                ...(s.textFont === "heading" ? { fontFamily: "var(--hedings-font, var(--primary-font, sans-serif))" } : {}),
                ...(s.slideTextSize ? { fontSize: s.slideTextSize } : {}),
            };
        },
    },
    emits: ["onClick"],
};
</script>
<style scoped>
.no-image {
    height: 300px;
    width: 100%;
    background-color: #f8f7f7;
    border-radius: 10px;
    color: #4e6078;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
